import { Box, FormControl, FormLabel, Typography } from '@mui/joy';
import { Dispatch, Fragment, useRef, useState } from 'react';
import { FileUpload, FileUploadOptions } from 'primereact/fileupload';
import { Avatar } from 'primereact/avatar';
import { Galleria } from 'primereact/galleria';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { Grid } from '@mui/material';
import { Dialog } from 'primereact/dialog';
import DocumentDetails from './DocumentDetails';
import { DataView } from 'primereact/dataview';
import { downloadFile, getRecordDocuments, removeDocument, removeMetaDocument, setDocumentHistoryDetails } from '../service/documentsService';
import GenericTableView from './GenericTableView';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { GenericTableColumTypes, GenericTableFilterTypes } from '../enum/TableView';
import { GenericTableColumns } from '../models/GenericTableViewModel';
import { consultantRemove, consultantUpdate } from '../service/consultantService';
import { FilterMatchMode } from 'primereact/api';
import { useNavigate } from 'react-router-dom';
import { RouteComponentProps } from '../models/RouteComponent';
import RiskAssessmentAdd from '../pages/risk-assessment/risk-assessment-Add';
import { addRiskAssessment, removeRiskAssessment } from '../service/riskAssessmentService';


interface inputPrams {
  record_id: string,
  client_id?: string,
  type: 'Employee' | 'Equipment' | 'Vehicle' | 'Chemical',
  setGlobalLoader: Dispatch<React.SetStateAction<boolean>>,
  props: RouteComponentProps
}


export default function RiskAssessmentComponent(prams: inputPrams) {
  const navigate = useNavigate();
  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const baseFilter = {}

  const queryParams: any = {
    'clientId': prams.client_id,
    record_id: prams.record_id,
    type: prams.type
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setSelectedRecord(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row)
    setSelectedRecord(row.value);
    editConfirm(row);
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setSelectedRecord(row.value);
  }

  const acceptFunc = async () => {
    prams.setGlobalLoader(true);
    const industry = await removeRiskAssessment(selectedRecord.id);
    prams.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Risk Deleted Successfully', life: 3000 });
  }

  const editConfirm = (row: any) => {
    setVisible(true);
  }

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }


  const unableToEdit = (row: any) => {
    toast.current.show({ severity: 'warning', summary: 'Unable To Edit Risk', life: 3000 });
  }

  const duplicate = (row: any) => {
    prams.setGlobalLoader(true);
    addRiskAssessment(
      {
        hazard: `${selectedRecord.hazard} Duplicate`,
        description: selectedRecord.description,
        responsible: selectedRecord.responsible,
        likelihood: selectedRecord.likelihood,
        consequence: selectedRecord.consequence,
        rating: selectedRecord.rating,
        control_measures: selectedRecord.control_measures,
        after_likelihood: selectedRecord.after_likelihood,
        after_consequence: selectedRecord.after_consequence,
        after_rating: selectedRecord.after_rating,
        job_step: selectedRecord.job_step,
        note: selectedRecord.note,
        client_id: prams.client_id
      }
    ).then((r: any) => {
      toast.current.show({ severity: 'success', summary: 'Risk Created Successfully', life: 3000 });
      prams.setGlobalLoader(false);
      setReload(!reload);
    }).catch((err) => {
      toast.current.show({ severity: 'error', summary: 'Failed to Create Risk', life: 3000 });
      prams.setGlobalLoader(false);
    })
  }

  const contextItems = () => {
    let objArray: any[] = [];
    objArray.push({ label: 'Duplicate', icon: 'pi pi-fw pi-copy', command: duplicate });
    if (prams.client_id === selectedRecord?.client_id || !prams.client_id) {
      objArray.push({ label: 'Edit', icon: 'pi pi-fw pi-pencil', command: editConfirm });
      objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    } else {
      objArray.push({ label: 'Unable To edit', icon: 'pi pi-fw pi-times-circle', command: unableToEdit });
    }
    return objArray;
  }



  const columns: GenericTableColumns[] = [
    {
      field: 'risk_id',
      header: 'Risk ID',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'hazard',
      header: 'Hazard',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'type',
      header: 'Type',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'record_name',
      header: 'Record Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'likelihood_label',
      header: 'Before Likelihood',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'consequence_label',
      header: 'Before Consequence',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'rating_label',
      header: 'Before Rating',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'after_likelihood_label',
      header: 'After Likelihood',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'after_consequence_label',
      header: 'After Consequence',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'after_rating_label',
      header: 'After Rating',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    }
  ];


  return (
    <Fragment>

      <GenericTableView reload={reload} queryParams={queryParams} dataKey='id' baseFilters={baseFilter} url="risk-assessment" columns={columns} contextItems={contextItems} itemSelect={itemSelected} addButton={addButton} contextItemSelected={contextItemSelected} />

      <Dialog ref={dialog} header={selectedRecord?.name ? `Upload ${selectedRecord.name} Document` : 'Add Risk'} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <RiskAssessmentAdd setGlobalLoading={prams.setGlobalLoader} setReload={setReload} reload={reload} details={selectedRecord} id={selectedRecord?.id} type={prams.type} record_id={prams.record_id} setVisible={setVisible} toast={toast} client={prams.client_id} />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />


    </Fragment>
  );
}